import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.push.js";
import getPx from '@/utils/getPx';
import { paperDetail, questionList, answerQuestion } from '@/api/mg';
export default {
  data: function data() {
    return {
      is_finish: '',
      isSuccess: false,
      isShowOptions: true,
      title: '',
      content: '',
      message: '',
      isStart: true,
      isEnd: false,
      isShow: false,
      num: 1,
      questions: [],
      isActive: true,
      transitionName: '',
      arr: ['Hot', 'Latest'],
      activeName: 'Hot',
      options: [],
      id: ''
    };
  },
  created: function created() {
    this.lineWidth = getPx(550 / this.questions.length * this.num);
    this.getPaperDetail({
      id: this.$route.query.id
    });
    // this.getQuestionList({ id: this.$route.query.id })
  },
  mounted: function mounted() {},
  // beforeCreate() {
  //   document.body.classList.add('fullScreen')
  // },
  // beforeDestroy() {
  //   console.log('remove')
  //   document.body.classList.remove('fullScreen')
  // },
  computed: {
    lineWidth: {
      get: function get() {
        return getPx(550 / this.questions.length * this.num);
      },
      set: function set(val) {
        console.log(val, 'val');
      }
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    getQuestionList: function getQuestionList(params) {
      var _this = this;
      questionList(params).then(function (res) {
        if (res.Code === 0) {
          _this.options = res.Data.chapter.options;
          _this.options.forEach(function (item) {
            item.selected = false;
          });
          console.log(_this.options, 'this.options');
          _this.message = '';
          var answer = res.Data.chapter.answer.answer;
          var type = res.Data.chapter.type;
          if (answer) {
            if (type === 3) {
              _this.message = answer[0];
            }
            if (type === 1 || type === 2) {
              _this.options.forEach(function (item) {
                answer.forEach(function (item1) {
                  console.log(item1, 'item1');
                  if (Number(item1) === item.id) {
                    item.selected = true;
                  }
                });
              });
            }
          }
        } else {
          _this.$message.error(res.Message);
        }
      });
    },
    getPaperDetail: function getPaperDetail(params) {
      var _this2 = this;
      paperDetail(params).then(function (res) {
        if (res.Code === 0) {
          _this2.title = res.Data.course.title;
          _this2.is_finish = res.Data.is_finish;
          _this2.content = res.Data.course.content;
          _this2.questions = res.Data.chapter;
          _this2.id = _this2.questions[_this2.num - 1].id;
          _this2.getQuestionList({
            id: _this2.id
          });
        } else {
          _this2.$message.error(res.Message);
        }
      });
    },
    last: function last() {
      if (this.num > 1) {
        this.isStart = false;
        this.isEnd = false;
        this.num--;
        this.id = this.questions[this.num - 1].id;
        this.getQuestionList({
          id: this.id
        });
      }
      if (this.num === 1) {
        this.isStart = true;
        // this.id = this.questions[this.num - 1].id
        // this.getQuestionList({ id: this.id })
      }
      // if (this.message) {
      //   this.message = ''
      // }
    },
    next: function next() {
      if (this.questions[this.num - 1].type === 3) {
        if (!this.message.trim()) {
          this.$toast($t('Incomplete information'));
          return;
        }
      }
      if (this.questions[this.num - 1].type === 2) {
        var arr = [];
        this.options.forEach(function (item) {
          if (item.selected) {
            arr.push(item.id);
          }
        });
        if (arr.length <= 1) {
          this.$toast('Incomplete information');
          return;
        }
      }
      if (this.questions[this.num - 1].type === 1) {
        var id;
        this.options.forEach(function (item) {
          if (item.selected) {
            id = item.id;
          }
        });
        if (!id) {
          this.$toast('Incomplete information');
          return;
        }
      }
      if (this.num === this.questions.length) {
        this.isEnd = true;
        this.submit();
        // const timer = setTimeout(() => {
        //   this.$router.back()
        //   clearTimeout(timer)
        // }, 3000)
        this.isSuccess = true;
        // this.id = this.questions[this.num - 1].id
        // this.getQuestionList({ id: this.id })
      }

      if (this.num < this.questions.length) {
        this.submit();
        this.isStart = false;
        this.isEnd = false;
        this.num++;
        this.id = this.questions[this.num - 1].id;
        this.getQuestionList({
          id: this.id
        });
      }
    },
    submit: function submit() {
      var _this3 = this;
      var params;
      if (this.questions[this.num - 1].type === 3) {
        params = {
          chapter_id: this.id,
          answer: this.message
        };
      }
      if (this.questions[this.num - 1].type === 2) {
        var arr = [];
        this.options.forEach(function (item) {
          if (item.selected) {
            arr.push(item.id);
          }
        });
        params = {
          chapter_id: this.id,
          answer: arr
        };
      }
      if (this.questions[this.num - 1].type === 1) {
        var id;
        this.options.forEach(function (item) {
          if (item.selected) {
            id = item.id;
          }
        });
        params = {
          chapter_id: this.id,
          answer: id
        };
      }
      answerQuestion(params).then(function (res) {
        if (res.Code === 0) {} else {
          _this3.$toast(res.Message);
        }
      });
    },
    hidePop: function hidePop() {
      this.isShow = false;
    },
    onSelect: function onSelect(index) {
      this.isShowOptions = false;
      this.options.forEach(function (item) {
        item.selected = false;
      });
      this.options[index].selected = true;
      this.isShowOptions = true;
    },
    onMultipleSelect: function onMultipleSelect(index) {
      this.isShowOptions = false;
      this.options[index].selected = !this.options[index].selected;
      this.isShowOptions = true;
    },
    toAnswer: function toAnswer() {
      this.isShow = true;
    }
  }
};